import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { activitySearchSchema } from "@/features/activity/activity-search"
import { ActivityLog } from "@/features/activity/components/activity-log"
import { activityQueries } from "@/queries/activity"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/activity/"
)({
  validateSearch: activitySearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) =>
    context.queryClient.ensureInfiniteQueryData(
      activityQueries.feed(
        { type: "individual", id: params.individualId },
        deps
      )
    ),
  component: IndividualActivityPage,
})

function IndividualActivityPage() {
  const { individualId } = Route.useParams()
  const filters = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Activity log" />
      <ActivityLog
        subject={{ type: "individual", id: individualId }}
        filters={filters}
        onFiltersChange={(search) => {
          void navigate({ replace: true, search })
        }}
      />
    </>
  )
}
